import './CasrcadeLockup.scss';

import classNames from 'classnames';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CASRCADE_LOGO_SRC } from '@constants/bridgeBio';

export interface CasrcadeLockupProps {
  className?: string;
  showAdh1Explainer?: boolean;
}

export const CasrcadeLockup = (props: CasrcadeLockupProps) => {
  const { className, showAdh1Explainer = false } = props;

  const adh1Popover = (
    <Popover id='casrcade-adh1-popover' className='casrcade-lockup-adh1-popover'>
      <Popover.Body>
        Autosomal dominant hypocalcemia, or ADH1, is a genetic form of hypoparathyroidism that causes low blood calcium
        among other clinical signs and symptoms and can be passed down in families or occur spontaneously
        <sup>1,2</sup> Changes (variants) in the calcium sensing receptor gene, <i>CASR</i>, cause ADH1.
      </Popover.Body>
    </Popover>
  );

  return (
    <div className={classNames('casrcade-lockup', className)}>
      <div className='d-flex flex-wrap align-items-start justify-content-between gap-3 column-gap-4 mb-4'>
        <div className='casrcade-lockup__brand'>
          <img className='casrcade-lockup__logo d-block mb-2' src={CASRCADE_LOGO_SRC} alt='CASRcade' />
          <p className='casrcade-lockup__tagline mb-0 fst-italic'>
            One positive genetic test can start a cascade of answers for a family
          </p>
        </div>

        {showAdh1Explainer && (
          <OverlayTrigger trigger='click' placement='bottom-end' overlay={adh1Popover} rootClose>
            <button
              type='button'
              className='casrcade-lockup__adh1-btn d-inline-flex align-items-center flex-shrink-0 gap-2'
            >
              <FontAwesomeIcon icon={faCircleInfo} className='text-accent-teal-1 fs-6' aria-hidden='true' />
              What is ADH1?
            </button>
          </OverlayTrigger>
        )}
      </div>

      <hr className='casrcade-lockup__divider' />
    </div>
  );
};
